import { render, staticRenderFns } from "./Cluster.vue?vue&type=template&id=2904f0ae"
import script from "./Cluster.vue?vue&type=script&lang=js"
export * from "./Cluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports